import { FC } from 'react';
import s from './kyc.module.scss';
import { Button } from '@components/UIKit/Button/Button';
import { useRouter } from 'next/router';
import { useTranslation } from '@hooks/useTranslation';
import { LinksEnum } from '@specs/navigation';
import { profile } from '@specs/specs';
import { formatRubyAmount } from '@specs/helpers';
import { minRubyWithdrawAmount } from '@specs/constants';
import { KYCType } from '@services/payments/model';
interface Props {
  kycStatus: KYCType;
  ruby: profile['ruby'];
}
export const KYC: FC<Props> = ({
  kycStatus,
  ruby
}) => {
  const router = useRouter();
  const {
    translate: tr
  } = useTranslation();
  const isDisabled = kycStatus === 'review' || kycStatus === 'completed' || formatRubyAmount(ruby) < minRubyWithdrawAmount;
  const clickHandler = async () => {
    if (isDisabled) return;
    await router.push(LinksEnum.USER_KYC);
  };
  return <div className={s.kyc} data-sentry-component="KYC" data-sentry-source-file="KYC.tsx">
            <div className={s.kyc__title}>
                {tr({
        id: 'withdraw.page.kyc.title'
      })}
            </div>
            <Button id={kycStatus ? 'default_button' : 'kyc_page_apply_button'} onClick={clickHandler} disabled={isDisabled} color={'Black'} size={'large'} data-sentry-element="Button" data-sentry-source-file="KYC.tsx">
                {tr({
        id: kycStatus === 'completed' ? 'verified' : kycStatus === 'review' ? 'kyc.processed' : 'kyc.apply'
      })}
            </Button>
            {kycStatus === 'error' &&
    // TODO: 1430 может вынести перевод в ошибки?
    <div className={s.kyc__error}>{tr({
        id: 'kyc.error'
      })}</div>}
        </div>;
};